import { Injectable } from "@angular/core";
import { RegionalSettingsDTO } from "../dto-models/regionalSettingsDTO.model";

declare global {
  interface Window {
    inlineManualOptions?: any;
    inline_manual_player?: {
      showPanel(): unknown;
      reinit?: () => void;
      options?: {
        language: string;
      };
    };
  }
}

@Injectable()
export class InlineManualService {
  public setLanguage(settings: RegionalSettingsDTO) {
    window.inlineManualOptions = {
      language: settings ? settings.language.substring(0, 2) : "en",
    };
    if (window.inline_manual_player && window.inline_manual_player.options) {
      window.inline_manual_player.options.language = settings
        ? settings.language.substring(0, 2)
        : "en";
      window.inline_manual_player.reinit();
    }
  }
}
